import moment, { Moment } from 'moment'
import React from 'react'
import { connect } from 'react-redux'

/*
  date: string | number
  We allow `date: string` because BE dates are stored as strings (moment parses this format by default)
  We allow `date: number` because passing in `numberInput.toString()` returns "Invalid date"
  since moment cannot infer what format the string is in (which would likely be `x`).
  We could add an additional prop inputFormat if we need to handle multiple string input formats in the future,
  but treating it as a number works just fine.
*/

export interface DateTimeProps {
  format: string // Long term goal: update to format enum to enforce consistent Date formatting
  date: string | number
}

// Formats used in extend:
// YYYY-MM-DD -> BE format
// MM/DD/YYYY
// l
// LL
// L
// ll
// LT
// dddd, LL
// H
// m
// MMM D
// h:mm A
// MMM
// Do
// MMMM D
// z
// MM/YY
// L [at] LTS
// MMM D, YYY
// HH:mm:ss
// LLL
// MM/DD/YYYY hh:mm:ss a
// dddd, Do MMM YYYY, h:mm:ss A
// YYYY-MM-DDTHH:mm:ss.SSSZZ

// ^ Ideally should use formats with multiple locale support - things starting with l or L

export const dateFormatMoment = (date: string | number): Moment => {
  return moment.utc(date)
}

export const dateFormatString = (
  date: string | number,
  format: string,
): string => {
  // Long term goal: use format enums to enforce consistency for date formats
  // Leaving it flexible for now
  // let format = ''
  // switch (props.format) {
  //   case DateTimeFormat.Short:
  //     format = 'l'
  //     break
  //   case DateTimeFormat.Long:
  //     format = 'LL'
  //     break
  // }

  return dateFormatMoment(date).format(format)
}

const Date: React.FC<DateTimeProps> = (props): React.ReactElement => {
  return <>{dateFormatString(props.date, props.format)}</>
}

const Dte = connect(() => ({}), {})(Date)

export default Dte
